import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavItem } from '../models/nav-item.model';
import { TokenClaimsService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  navItems = new BehaviorSubject<NavItem[]>(null);
  navItems$ = this.navItems.asObservable();

  ecText: string = 'Energy Credits';
  qbText: string = 'CQMS';
  fcText: string = 'Facility Configuration';
  qbUserText: string = 'CQMS Users';

  constructor(private claimsService: TokenClaimsService) {
  }

  createNavBar() {
    let navLinks: NavItem[] = [];

    //Corp Admin
    if (this.claimsService.canAccessHomeOfficeAdmin) {
      let corpAdmin: NavItem = {
        Name: 'Corporate Admin',
        Active: false,
        IconUrl: './assets/nav-icons/ca-icon-white.svg',
        Url: 'corp-admin/task-management',
      };
      navLinks.push(corpAdmin);
    }

    //Energy Credits
    if (this.claimsService.canAccessEC) {
      let energy: NavItem = {
        Name: this.ecText,
        Active: false,
        IconUrl: './assets/nav-icons/ec-icon-white.svg',
        Url: 'energy-credits',
      };
      navLinks.push(energy);
    }

    //QBuilt
    if (this.claimsService.canAccessQBuilt) {
      let qbuilt: NavItem = {
        Name: this.qbText,
        Active: false,
        IconUrl: './assets/nav-icons/qb-icon-white.svg',
        Url: 'cqms',
      };
      navLinks.push(qbuilt);
    }

    //QBuilt - facility config
    if (this.claimsService.canAccessQBuilt) {
      let facilityConfig: NavItem = {
        Name: this.fcText,
        Active: false,
        IconUrl: './assets/nav-icons/fc-icon-white.svg',
        Url: 'facility-configuration',
      };
      navLinks.push(facilityConfig);
    }

    //QBuilt - user assignments
    if (this.claimsService.canAccessQBuilt) {
      let userAssignments: NavItem = {
        Name: this.qbUserText,
        Active: false,
        IconUrl: './assets/nav-icons/peeps-white.svg',
        Url: 'cqms/users',
      };
      navLinks.push(userAssignments);
    }

    //TEMP INSPECTOR ICON -- WILL REMOVE
    if(this.claimsService.isAdmin) {
      let inspector: NavItem = {
        Name: 'TEMP CQMS Inspector',
        Active: false,
        IconUrl: '',
        Url: 'cqms-home',
      };
      navLinks.push(inspector);
    }

    // NOTE: Commenting out until eLearn has content
    // let eLearn: NavItem = {
    //   Name: 'eLearn',
    //   Active: false,
    //   IconUrl: './assets/nav-icons/el-icon.svg',
    //   Url: 'e-learn',
    // };
    // navLinks.push(eLearn);

    this.navItems.next(navLinks);
    this.checkEmptyRoute();
  }

  setActive(name: string) {
    let items = this.navItems.value;

    items?.forEach((i) => {
      if (i.Name === name) {
        i.Active = true;
      } else {
        i.Active = false;
      }
    });

    this.navItems.next(items);
  }

  checkEmptyRoute() {
    const currentRoute = window.location.pathname;
    if(currentRoute === '/') {
      if(this.claimsService.canAccessQBuilt) {
        this.setActive(this.qbText);

      } else {
        this.setActive(this.ecText);
      }
    }

  }
}
